import React, { Component } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export function withRouter(Component) {
    return function ComponentWithRouterProps(props) {
        let location = useLocation();
        let params = useParams();
        return <Component {...props} location={location} params={params} />;
    };
}
